import { sendApiRequest } from '../lib/helper';
import { IAuthenticationStatusContext } from '../types/IAuthenticationStatusContext';
import { ISemester } from "../types/ICourse";

export const sortSemesters = ((a: ISemester, b: ISemester) => {
    let retVal = -1;
    if(a.Year === b.Year)
    {
        if(a.Semester === "Fall" && (b.Semester === "Summer" || b.Semester === "Spring"))
        {
            retVal = -1;
        }
        else if(a.Semester === "Summer" && b.Semester === "Spring")
        {
            retVal = -1;
        }
        else
        {
            retVal = 1;
        }
    }
    else
    {
        return a.Year < b.Year ? 1 : -1
    } 
    return retVal;
});

export const getSemesters = (authContextResult: IAuthenticationStatusContext): Promise<ISemester[]> => {

    let promises = [sendApiRequest("/api/blobStorage/getListOfSemestersFromBlobStorage", "GET")];   
    promises.push(sendApiRequest("/api/canvas/getListOfSemestersFromCanvas", "GET").then(res => res).catch(err => ([])));
    
    return Promise.all(promises).then(results => {
        const blobSemesters = results[0];
        let canvasSemesters = undefined;
        if(promises.length === 2)
        {
            canvasSemesters = results[1];
        }      
        let semesters: ISemester[] = canvasSemesters;

        if(!semesters)
        {
            semesters = blobSemesters;
        }
        else
        {
            semesters = semesters.concat(blobSemesters);
        }
   
        return semesters.sort(sortSemesters);
    });  
};
